/* Layout */
import Layout from '../../views/layout/Layout.vue'

const DealPostList = () => import(/* webpackChunkName: "deal-post-list" */ '@/views/deal-post/list')
const DealPostDetail = () => import(/* webpackChunkName: "deal-post-detail" */ '@/views/deal-post/detail')

export default [
  {
    path: '/deal-post',
    component: Layout,
    redirect: '/deal-post/list',
    name: 'Deal Post',
    alwaysShow: true,
    meta: {
      title: 'dealPost',
      icon: 'images',
    },
    children: [
      {
        path: 'create',
        component: DealPostDetail,
        name: 'DealPostCreate',
        meta: {
          title: 'create',
          icon: 'edit',
          accessibleName: 'deal-post',
        },
      },
      {
        path: 'edit/:id',
        component: DealPostDetail,
        props: true,
        name: 'DealPostEdit',
        hidden: true,
        meta: {
          title: 'edit',
          accessibleName: 'deal-post',
        },
      },
      {
        path: 'list',
        component: DealPostList,
        name: 'DealPostList',
        meta: {
          title: 'list',
          icon: 'list',
          accessibleName: 'deal-post',
        },
      },
    ],
  },
]
